<template>
  <v-container fill-height>
    <v-row align="center">
      <v-col cols="12" offset-md="3" md="6" offset-sm="1" sm="10">
        <v-card class="elevation4">
          <v-toolbar color="primary" dark>
            <v-toolbar-title>Сброс пароля</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form v-model="valid" ref="form">
              <v-text-field
                label="Email"
                v-model="email"
                autofocus
                required
                :rules="[
                  validation.emailIsRequired,
                  validation.emailMustBeValid
                ]"
              />
              <v-label>
                Введите e-mail, указанный при регистрации и мы скоро пришлем на
                него новый пароль
              </v-label>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn block dark class="primary" @click="doReset">
              Сбросить
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { stored } from '../lib/Utils'
import validation from '../lib/Validation'
import { mapMutations, mapActions } from 'vuex'
export default {
  name: 'Reset',
  data() {
    return {
      email: stored('last-username'),
      validation,
      valid: false
    }
  },
  methods: {
    doReset() {
      this.$refs.form.validate()
      if (this.valid) {
        this.request({
          url: 'auth/reset',
          method: 'post',
          data: {
            email: this.email
          }
        }).then(() => {
          this.$router.push({ name: 'login' })
        })
      } else {
        this.message({
          text: 'Пожалуйста устраните замечания',
          color: 'error'
        })
      }
    },
    ...mapMutations(['message']),
    ...mapActions(['request'])
  }
}
</script>
